import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointValue } from '@chakra-ui/react';
export const useResponsiveBreaksInTextFormatValues = () => {
    const brOnLg = useBreakpointValue({
        base: '',
        lg: _jsx("br", {}),
    }) || '';
    const brOnLgOrSpace = useBreakpointValue({
        base: ' ',
        lg: _jsx("br", {}),
    }) || ' ';
    const brOnMd = useBreakpointValue({
        base: '',
        md: _jsx("br", {}),
        lg: '',
    }) || '';
    const brOnMdOrSpace = useBreakpointValue({
        base: ' ',
        md: _jsx("br", {}),
        lg: ' ',
    }) || ' ';
    const brOnSm = useBreakpointValue({
        base: _jsx("br", {}),
        md: '',
    }) || '';
    const brOnSmOrSpace = useBreakpointValue({
        base: _jsx("br", {}),
        md: ' ',
    }) || ' ';
    const spaceOnLg = useBreakpointValue({
        base: '',
        lg: ' ',
    }) || '';
    const spaceOnMd = useBreakpointValue({
        base: '',
        md: ' ',
        lg: '',
    }) || '';
    const spaceOnSm = useBreakpointValue({
        base: ' ',
        md: '',
    }) || '';
    return {
        brOnLg,
        brOnLgOrSpace,
        brOnMd,
        brOnMdOrSpace,
        brOnSm,
        brOnSmOrSpace,
        spaceOnLg,
        spaceOnMd,
        spaceOnSm,
    };
};
